import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">Galataya · Fine Art & Collectibles</p>
        <h1>Discover Unique Art for Your Home</h1>
        <p className="lede">
          Explore our curated collection of fine art pieces, collectibles, and home decor that elevate your living space and reflect your personal style.
        </p>
        <div className="cta-row">
          <a href="/shop" target="_blank">
            Shop Now
          </a>
          <a href="/about" target="_blank" className="secondary">
            Learn More
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Curated Collections</h2>
          <p>
            Browse through our exclusive selections of art and decor, handpicked to inspire and delight.
          </p>
        </article>
        <article>
          <h2>Art for Every Taste</h2>
          <p>
            From contemporary pieces to timeless classics, find the perfect artwork that resonates with you.
          </p>
        </article>
        <article>
          <h2>Transform Your Space</h2>
          <p>
            Discover how our unique decor items can enhance your home and create an inviting atmosphere.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;